import { render, staticRenderFns } from "./InstanceTenants.vue?vue&type=template&id=a48a20de&scoped=true&"
import script from "./InstanceTenants.vue?vue&type=script&lang=js&"
export * from "./InstanceTenants.vue?vue&type=script&lang=js&"
import style0 from "./InstanceTenants.vue?vue&type=style&index=0&id=a48a20de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48a20de",
  null
  
)

export default component.exports